"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonHeightT = exports.SkeletonHeight = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class SkeletonHeight {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsSkeletonHeight(bb, obj) {
        return (obj || new SkeletonHeight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsSkeletonHeight(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new SkeletonHeight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    hmdHeight() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    floorHeight() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : null;
    }
    static startSkeletonHeight(builder) {
        builder.startObject(2);
    }
    static addHmdHeight(builder, hmdHeight) {
        builder.addFieldFloat32(0, hmdHeight, 0);
    }
    static addFloorHeight(builder, floorHeight) {
        builder.addFieldFloat32(1, floorHeight, 0);
    }
    static endSkeletonHeight(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createSkeletonHeight(builder, hmdHeight, floorHeight) {
        SkeletonHeight.startSkeletonHeight(builder);
        if (hmdHeight !== null)
            SkeletonHeight.addHmdHeight(builder, hmdHeight);
        if (floorHeight !== null)
            SkeletonHeight.addFloorHeight(builder, floorHeight);
        return SkeletonHeight.endSkeletonHeight(builder);
    }
    unpack() {
        return new SkeletonHeightT(this.hmdHeight(), this.floorHeight());
    }
    unpackTo(_o) {
        _o.hmdHeight = this.hmdHeight();
        _o.floorHeight = this.floorHeight();
    }
}
exports.SkeletonHeight = SkeletonHeight;
class SkeletonHeightT {
    constructor(hmdHeight = null, floorHeight = null) {
        this.hmdHeight = hmdHeight;
        this.floorHeight = floorHeight;
    }
    pack(builder) {
        return SkeletonHeight.createSkeletonHeight(builder, this.hmdHeight, this.floorHeight);
    }
}
exports.SkeletonHeightT = SkeletonHeightT;
